import styled from 'styled-components';

export const Overlay = styled.div<{$ZIndex: number}>`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: ${({$ZIndex}) => $ZIndex};
`;

export const Container = styled.div`
    background: white;
    border-radius: 12px;
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.25);
    padding: 40px;
    max-width: 760px;
    width: 90%;
    aspect-ratio: 16 / 9;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;

export const IconWrapper = styled.div`
    width: 56px;
    height: 56px;
    flex-shrink: 0;

    svg {
        width: 100%;
        height: 100%;
        fill: #2ca8e7;
    }
`;

export const Header = styled.div`
    display: flex;
    align-items: center;
    align-self: flex-start;
    gap: 16px;

    h2 {
        margin: 0;
        font-size: 2.6rem;
        font-weight: bold;
        color: black;
    }
`;

export const Content = styled.div`
    margin: 28px 0;
    font-size: 2.2rem;
    line-height: 1.5;
    word-break: break-word;
    color: black;
    text-align: center;
`;

export const ButtonsWrapper = styled.div`
    display: flex;
    gap: 10px;
    width: 100%;
    margin-top: 32px;
`;

export const Button = styled.button<{$focused: boolean}>`
    flex: 1;
    font-size: 1.8rem;
    font-weight: bold;
    border: none;
    border-radius: 8px;
    padding: 20px 28px;
    cursor: pointer;
    background-color: ${({$focused}) => ($focused ? '#2ca8e7' : '#ddd')};
    color: ${({$focused}) => ($focused ? 'white' : 'black')};

    &:hover {
        background-color: #1a90c6;
    }
`;
